import { ViewModel,View } from "binder"
import  { GuageView } from "./guage-view"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ContentPropertyType, FloatPropertyType, IntegerPropertyType, StringPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import { FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";


export class GuageComponent extends FormBuilderComponent{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.name = 'Guage';
        this.canAcceptContent = false;
        this.canAcceptMultipleContent = false;

        this.addProperty("Config","data-b-comp-config",new ContentPropertyType(this),null,false);
        this.addProperty("Value","data-b-comp-value",new FloatPropertyType(this),0,false);
        this.addProperty("Title","data-b-comp-title",new StringPropertyType(this),null,false);
    }
    
    CreateInternal(parent: ViewModel): FormBuilderElement {
        let result = new GuageElement(parent);
        return result;    
    }
    
}
export class GuageElement extends FormBuilderElement{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new GuageView();
    }
    public getTypeId(): string {
        return "VM-3C5A3150-D89B-419B-A4A3-E5F1AF1C4A0F"
    }
    public set Config(v: any) { this._Config = v; } public get Config(): any { return this._Config;} private _Config: any;
    public set Value(v: number) { this._Value = v; } public get Value(): number { return this._Value;} private _Value: number;
    public set title(v: string) { this._title = v; } public get title(): string { return this._title;} private _title: string;
        
    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitGuage(this,parameter);
    }
    
}
